module.exports = __webpack_public_path__ + "assets/img/loading-4009bf98.gif";